import * as React from 'react';
import Switch from '../Switch';
import Route from '../Route';
import TabsHeader from './Header';
import TabsPane from './Pane';

var RouterTabs = function RouterTabs(_ref) {
  var children = _ref.children;
  var tabs = [];
  var routes = [];
  React.Children.forEach(children, function (child, index) {
    if (!child) {
      return;
    }

    var _child$props = child.props,
        title = _child$props.title,
        path = _child$props.path,
        exact = _child$props.exact,
        strict = _child$props.strict;

    var childRenderer = function childRenderer() {
      return React.cloneElement(child);
    };

    var route = {
      path: path,
      exact: exact,
      strict: strict
    };
    tabs.push({
      key: index,
      title: title,
      route: route
    });
    routes.push({
      key: index,
      props: route,
      renderer: childRenderer
    });
  });
  return React.createElement("div", {
    className: "Tabs"
  }, React.createElement(TabsHeader, {
    items: tabs
  }), React.createElement("div", {
    className: "Tabs__content",
    role: "tabpanel"
  }, React.createElement(Switch, null, routes.map(function (_ref2) {
    var key = _ref2.key,
        props = _ref2.props,
        renderer = _ref2.renderer;
    return React.createElement(Route, Object.assign({
      key: key
    }, props, {
      render: renderer
    }));
  }))));
};

RouterTabs.Pane = TabsPane;
export default RouterTabs;